import React from "react";
import "../css/about.scss";
import { STORE_CONFIG } from "../config/store";

function About() {
  return <main id="main"><article id="our-story" className="page entry container">
    <header><div className="title-bar"><h1 className="main-heading">About {STORE_CONFIG.brand}</h1></div></header>
    <section className="entry-content">
      <img src="/assets/editorial/about.jpg" alt="A calm Hong Kong workspace with reusable home goods and paper parcels" />
      <h2>Useful things, described with care.</h2>
      <p>fumvella is a Hong Kong-operated online storefront for kitchen, home, personal-care and everyday carry goods. Product pages present the supplied format, included pieces, care guidance and applicable use limits.</p>
      <p>Every food-contact listing pairs its product configuration with a required material, use-limit and batch-evidence specification that each delivered unit must match. Pressure containers, unlabelled cosmetics and household contents, filled heatable-looking items and unlabelled candles stay unavailable until their required identity and safety documents are reviewed.</p>
      <p>For help with a product, an order or an accessibility need, email <a href={`mailto:${STORE_CONFIG.customerServiceEmail}`}>{STORE_CONFIG.customerServiceEmail}</a>. We do not publish a phone number or street address because neither has been confirmed for this project.</p>
    </section>
  </article></main>;
}
export default About;
